'use client';

import type { ChoiceType } from '~/model/ChoiceType';

export const RankingResult = ({
  resultData,
  resultId,
  answerChoices,
}: RankingResultPropsType) => {
  let previousValue = 0;
  let position = 0;

  return (
    <div className="control-sortable" data-testid="ranking">
      <ul>
        {resultData
          && resultData.map((item: Data, index: number) => {
            const { points } = item;
            const choice
              = answerChoices?.length > 0
                && answerChoices.find(q => q['@id'] === item['@id']).title;
            const newPosition
              = points === previousValue ? position : position + 1;
            position = index === 0 ? 0 : newPosition;
            previousValue = points;
            return (
              <li className="list-drag" key={`ranking-${resultId}-${index}`}>
                <div className="index-drag" data-testid="ranking-position">
                  {position + 1}
&nbsp;-&nbsp;
                </div>
                <div className="label-drag" data-cy="sortLabel">
                  {choice}
                </div>
                <div className="handle" />
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export interface RankingResultPropsType {
  resultId: number;
  resultData: Data[];
  answerChoices: ChoiceType[];
}

interface Data {
  '@id': string;
  choice: string;
  points: number;
}
